module.exports = __webpack_public_path__ + "static/media/food-app-1.d128c1d9.jpg";